import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import moment from 'moment'
import { Modal } from 'react-bootstrap'

import { PeriodPicker } from '../../../common/period_picker'
import * as periodPickerConstants from '../../../common/period_picker/constants'
import * as formatters from '../../../common/formatters'
import { LoadingOverlay } from '../../../common/loading_overlay'

import * as ReportVehicleProfitsActionCreators from '../actionCreators'
import { getYear, getData, getFetching, getDetailsData, getDetailsFetching } from '../selectors'

import { prepareTableActionCreators } from '../../../common/table/actionCreators'
import { getActiveFilters } from '../../../common/table/helpers'
import { createTableModelSelector } from '../../../common/table/selectors'

import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'
import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'
import CheckboxField from "../../../common/form/components/CheckboxField";
import InputField from "../../../common/form/components/InputField";
import * as helpers from "../../../common/helpers";
import { DispatchersBox } from "../../../common/colored_box";
import { SimpleSelectField } from "../../../common/form";

const componentIdentifier = 'report_vehicle_profits'
const prerequisites = ['dispatchers', 'company_cost_centers']

const tableIdentifier = 'report_vehicle_profits'

class ReportVehicleProfits extends Component {
    state = {
        modalDetails: {
            show: false,
            id: null,
            month: null,
            name: null
        },
        inclCostCenters: true,
        inclDrivers: true,
        inclTrailers: true,
        inclFeatureCosts: true,
        filters: {}
    }

    // list
    getYear = () => {
        if (this.props.year) {
            return parseInt(this.props.year)
        }

        return parseInt(this.props.match.params.year ? this.props.match.params.year : moment().format('YYYY'))
    }

    refresh = () => {
        this.props.actions.fetchReportVehicleProfits(this.getYear(), this.state.filters, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
    }

    resetFilters = () => {
        this.props.table.resetFilters()
    }

    isFilterActive = () => getActiveFilters(this.props.tableModel).size > 0

    handleChangeYearMonth = format => {
        const year = format.year.toString()
        const path = `/report-vehicle-profits/${year}`
        this.props.history.push(path)
    }

    handleChangeFilter = (key, val) => {
        this.setState({
            ...this.state,
            filters: {
                ...this.state.filters,
                [key]: val
            }
        }, () => {
            this.refresh()
        })
    }

    changeInclCostCenters = value => {
        this.setState({
            ...this.state,
            inclCostCenters: value
        }, () => {
            this.state.modalDetails.show ? this.refreshDetails() : this.refresh()
        })
    }

    changeInclDrivers = value => {
        this.setState({
            ...this.state,
            inclDrivers: value
        }, () => {
            this.state.modalDetails.show ? this.refreshDetails() : this.refresh()
        })
    }

    changeInclTrailers = value => {
        this.setState({
            ...this.state,
            inclTrailers: value
        }, () => {
            this.state.modalDetails.show ? this.refreshDetails() : this.refresh()
        })
    }

    changeInclFeatureCosts = value => {
        this.setState({
            ...this.state,
            inclFeatureCosts: value
        }, () => {
            this.state.modalDetails.show ? this.refreshDetails() : this.refresh()
        })
    }

    // export
    handleExport = e => {
        e && e.preventDefault()

        this.props.actions.exportReportVehicleProfits(this.getYear(), this.state.filters, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
    }

    // detail
    handleShowDetails = (e, id, month, name) => {
        e && e.preventDefault()

        this.setState({
            modalDetails: {
                show: true,
                id,
                month,
                name
            },
        }, () => {
            this.props.actions.fetchReportVehicleProfitsDetails(id, this.getYear(), 0, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
        })
    }

    handleHideDetails = e => {
        e && e.preventDefault()

        this.setState({
            modalDetails: {
                show: false,
                id: null,
                month: null,
                name: null,
            },
        }, () => {
            this.refresh()
            this.props.actions.clearReportVehicleProfitsDetails()
        })
    }

    refreshDetails = () => {
        this.props.actions.fetchReportVehicleProfitsDetails(this.state.modalDetails.id, this.getYear(), 0, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
    }

    // export detail
    handleExportDetails = e => {
        e && e.preventDefault()

        this.props.actions.exportReportVehicleProfitsDetails(this.state.modalDetails.id, this.getYear(), 0, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
    }

    componentDidMount() {
        this.props.actions.fetchReportVehicleProfits(this.getYear(), this.state.filters, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
        this.props.actions.fetchPrerequisites()
    }

    componentWillUnmount() {
        this.props.actions.clearReportVehicleProfits()
    }

    componentWillReceiveProps(nextProps) {
        const parsedYear = parseInt(nextProps.match.params.year ? nextProps.match.params.year : moment().format('YYYY'))

        if (parsedYear !== this.getYear()) {
            this.props.actions.clearReportVehicleProfits()
            this.props.actions.fetchReportVehicleProfits(parsedYear, this.state.filters, this.state.inclCostCenters, this.state.inclDrivers, this.state.inclTrailers, this.state.inclFeatureCosts)
        }
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.reportVehicleProfits.heading' }))

        const data = this.props.data && this.props.data.vehicles
        const total = this.props.data && this.props.data.total

        const detailsData = this.props.detailsData && this.props.detailsData

        const momentFrom = moment(`${this.getYear()}-01-01`, 'YYYY-MM-DD')
        const momentTo = moment(momentFrom).endOf('year')

        const monthKeys = [...Array(12).keys()]

        return (<PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
            <div className="page-inner">
                <div id="main-wrapper">
                    <div className="panel panel-white">
                        <div className="panel-body">
                            <div className="wp-100 pull-left m-b-xs">
                                <h4 className="pull-left">
                                    <span className="pull-left">
                                        <FormattedMessage id="modules.reportVehicleProfits.heading" />
                                    </span>
                                </h4>

                                <div className="pull-left" style={{ marginLeft: '100px' }}>
                                    <span className="pull-left text-gray" style={{ paddingTop: '10px' }}>
                                        <FormattedMessage id="fields.show_costs" />:
                                    </span>
                                    <div className="pull-left m-l-sm">
                                        <CheckboxField
                                            id="incl_cost_centers"
                                            onChange={(e) => { this.changeInclCostCenters(e.target.checked) }}
                                            label={this.props.intl.formatMessage({ id: 'fields.incl_cost_centers' })}
                                            value={this.state.inclCostCenters}
                                        />
                                    </div>
                                    <div className="pull-left m-l-sm">
                                        <CheckboxField
                                            id="incl_drivers"
                                            onChange={(e) => { this.changeInclDrivers(e.target.checked) }}
                                            label={this.props.intl.formatMessage({ id: 'fields.incl_drivers' })}
                                            value={this.state.inclDrivers}
                                        />
                                    </div>
                                    <div className="pull-left m-l-sm">
                                        <CheckboxField
                                            id="incl_trailers"
                                            onChange={(e) => { this.changeInclTrailers(e.target.checked) }}
                                            label={this.props.intl.formatMessage({ id: 'fields.incl_trailers' })}
                                            value={this.state.inclTrailers}
                                        />
                                    </div>

                                    <div className="pull-left" style={{marginLeft: '100px'}}>
                                        <CheckboxField
                                            id="incl_feature_costs"
                                            onChange={(e) => { this.changeInclFeatureCosts(e.target.checked) }}
                                            label={this.props.intl.formatMessage({ id: 'fields.incl_feature_costs' })}
                                            value={this.state.inclFeatureCosts}r
                                        />
                                    </div>
                                </div>

                                <div className="btns-list">
                                    <PeriodPicker
                                        className={'m-r-sm'}
                                        momentFrom={momentFrom}
                                        momentTo={momentTo}
                                        onChange={(momentFrom, momentTo, format) => this.handleChangeYearMonth(format)}
                                        allowedPickers={[periodPickerConstants.PERIOD_PICKER_TYPE_YEAR]}
                                        forbidPickType
                                    />
                                    {this.isFilterActive() > 0 && (<button className="btn btn-default btn-addon m-r-xs" onClick={this.resetFilters}>
                                        <i className="far fa-times" /> <FormattedMessage id="buttons.resetFilters" />
                                    </button>)}
                                    <button className="btn btn-default btn-addon m-r-xs" onClick={this.refresh}>
                                        <i className="far fa-sync-alt" /> <FormattedMessage id="buttons.refresh" />
                                    </button>
                                    <PermissionsCheck has={[PERMS.EXPORT]}>
                                        <button className="btn btn-primary btn-addon" onClick={this.handleExport}>
                                            <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                        </button>
                                    </PermissionsCheck>
                                </div>
                            </div>

                            <div className="table-container">
                                <table className="table table-striped table-hover table-fixed-header">
                                    <thead>
                                    <tr>
                                        <th className="w-max wm-200" />


                                        <th className="w-140">
                                            <FormattedMessage id="fields.dispatcher" />
                                        </th>

                                        <th className="w-100">
                                            <FormattedMessage id="fields.costCenter" />
                                        </th>

                                        {monthKeys.map(key => {
                                            const month = moment().set('month', key)

                                            return (<th key={`th-month-${key}`} className="w-100 text-right">
                                                {this.props.intl.formatMessage({ id: `monthNames.${month.format('MM')}` })}
                                            </th>)
                                        })}

                                        <th className="w-140 text-right">
                                            <FormattedMessage id="fields.total" />
                                        </th>
                                    </tr>

                                    <tr className="filters">
                                        <th className="w-max wm-200">
                                            <InputField
                                                id="vehicle_name"
                                                onChange={(e) => { this.handleChangeFilter('vehicle_name', e.target.value) }}
                                                value={this.state.filters.vehicle_name}
                                                formGroupClassName="m-b-no"
                                            />
                                        </th>
                                        <th className="w-140">
                                            <SimpleSelectField
                                                id="dispatcher_id"
                                                onChange={(e) => { this.handleChangeFilter('dispatcher_id', e.target.value) }}
                                                value={this.state.filters.dispatcher_id}
                                                values={helpers.getPrerequisitesArray(this.props.prerequisites.values.get('dispatchers'))}
                                                formGroupClassName="m-b-no"
                                                className="wp-100"
                                                nullable
                                            />
                                        </th>
                                        <th className="w-100">
                                            <SimpleSelectField
                                                id="company_cost_center_id"
                                                onChange={(e) => { this.handleChangeFilter('company_cost_center_id', e.target.value) }}
                                                value={this.state.filters.dispatcher_id}
                                                values={helpers.getPrerequisitesArray(this.props.prerequisites.values.get('company_cost_centers'))}
                                                formGroupClassName="m-b-no"
                                                className="wp-100"
                                                nullable
                                            />
                                        </th>

                                        {monthKeys.map(key => (<th key={`filter-month-${key}`} className="w-100" />))}

                                        <th className="w-140 text-right" />
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {data && data.map(row => {
                                        const total = row.data.total

                                        if (parseInt(row.is_active) === 0 && total === 0) {
                                            return null
                                        }

                                        return (<tr key={`row-${row.id}`}>
                                            <td className="w-max wm-200 td-clickable" onClick={e => {
                                                this.handleShowDetails(e, row.id, 0, row.name)
                                            }}>
                                                <DispatchersBox dispatcher={row.dispatcher}>{row.name}</DispatchersBox>
                                                {row.cost_centers.length > 0 && (
                                                    <span className="text-gray">
                                                       &nbsp;+ {row.cost_centers.length} {row.cost_centers.length === 1 ? 'středisko' : (row.cost_centers.length <= 4 ? 'střediska' : 'středisek')}
                                                    </span>
                                                )}
                                                {row.drivers.length > 0 && (
                                                    <span className="text-gray">
                                                       &nbsp;+ {row.drivers.length} {row.drivers.length === 1 ? 'řidič' : (row.drivers.length <= 4 ? 'řidiči' : 'řidičů')}
                                                    </span>
                                                )}
                                                {row.trailers.length > 0 && (
                                                    <span className="text-gray">
                                                       &nbsp;+ {row.trailers.length} {row.trailers.length === 1 ? 'návěs' : (row.trailers.length <= 4 ? 'návěsy' : 'návěsů')}
                                                    </span>
                                                )}
                                            </td>

                                            <td className="w-140">
                                                {row.dispatcher ? formatters.shortFullName(row.dispatcher.first_name, row.dispatcher.last_name) : ''}
                                            </td>

                                            <td className="w-100">
                                                {row.company_cost_center ? row.company_cost_center.code : ''}
                                            </td>

                                            {monthKeys.map(monthKey => {
                                                const price = row.data.months[monthKey + 1]

                                                return (
                                                    <td key={`row-${row.id}-month-${monthKey}`} className={`w-100 text-right td-clickable ${price < 0 ? 'td-danger' : ''}`} onClick={e => {
                                                        this.handleShowDetails(e, row.id, monthKey + 1, row.name)
                                                    }}>
                                                        {price ? formatters.priceFormatter(price, '0,0') : ''}
                                                    </td>)
                                            })}

                                            <td className={`w-140 text-right td-clickable ${total < 0 ? 'td-danger' : ''}`} onClick={e => {
                                                this.handleShowDetails(e, row.id, 0, row.name)
                                            }}>
                                                <strong>
                                                    {formatters.priceFormatter(total, '0,0')}
                                                </strong>
                                            </td>
                                        </tr>)
                                    })}

                                    {total && (<tr>
                                        <td>
                                            <strong>
                                                <FormattedMessage id="fields.total" />
                                            </strong>
                                        </td>

                                        <td></td>
                                        <td></td>

                                        {monthKeys.map(monthKey => {
                                            const price = total.months[monthKey + 1]

                                            return (<td key={`total-month-${monthKey}`} className={`w-100 text-right ${price < 0 ? 'td-danger' : ''}`}>
                                                <strong>
                                                    {formatters.priceFormatter(price, '0,0')}
                                                </strong>
                                            </td>)
                                        })}

                                        <td className={`w-100 text-right ${total['total'] < 0 ? 'td-danger' : ''}`}>
                                            <strong>
                                                {formatters.priceFormatter(total['total'], '0,0')}
                                            </strong>
                                        </td>
                                    </tr>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal show={Boolean(this.state.modalDetails.show)} onHide={this.handleHideDetails} className="modal-size-auto">
                    <Modal.Header closeButton>
                        <Modal.Title>{`${this.state.modalDetails.name} / ${momentFrom.format('DD.MM.YYYY')} - ${momentTo.format('DD.MM.YYYY')}`}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="clearfix">
                        <LoadingOverlay active={this.props.detailsFetching}>
                            <div className="pull-left wp-100 mh-500">
                                <div className="pull-left wp-100 m-b-sm">
                                    <div className="pull-left">
                                        <span className="pull-left text-gray" style={{ paddingTop: '10px' }}>
                                            <FormattedMessage id="fields.show_costs" />:
                                        </span>
                                        <div className="pull-left m-l-sm">
                                            <CheckboxField
                                                id="incl_cost_centers"
                                                onChange={(e) => { this.changeInclCostCenters(e.target.checked) }}
                                                label={this.props.intl.formatMessage({ id: 'fields.incl_cost_centers' })}
                                                value={this.state.inclCostCenters}
                                            />
                                        </div>
                                        <div className="pull-left m-l-sm">
                                            <CheckboxField
                                                id="incl_drivers"
                                                onChange={(e) => { this.changeInclDrivers(e.target.checked) }}
                                                label={this.props.intl.formatMessage({ id: 'fields.incl_drivers' })}
                                                value={this.state.inclDrivers}
                                            />
                                        </div>
                                        <div className="pull-left m-l-sm">
                                            <CheckboxField
                                                id="incl_trailers"
                                                onChange={(e) => { this.changeInclTrailers(e.target.checked) }}
                                                label={this.props.intl.formatMessage({ id: 'fields.incl_trailers' })}
                                                value={this.state.inclTrailers}
                                            />
                                        </div>

                                        <div className="pull-left" style={{marginLeft: '100px'}}>
                                            <CheckboxField
                                                id="incl_feature_costs"
                                                onChange={(e) => { this.changeInclFeatureCosts(e.target.checked) }}
                                                label={this.props.intl.formatMessage({ id: 'fields.incl_feature_costs' })}
                                                value={this.state.inclFeatureCosts}
                                            />
                                        </div>
                                    </div>

                                    <div className="btns-list">
                                        <PermissionsCheck has={[PERMS.EXPORT]}>
                                            <button className="btn btn-primary btn-addon" onClick={this.handleExportDetails}>
                                                <i className="far fa-file-excel" /> <FormattedMessage id="buttons.exportToXLS" />
                                            </button>
                                        </PermissionsCheck>
                                    </div>

                                    {detailsData && (<div className="pull-left wp-100">
                                        <div className="table-container">
                                            <table className="table table-striped table-hover table-fixed-header">
                                                <thead>
                                                <tr>
                                                    <th className="w-max wm-300" />
                                                    {monthKeys.map(key => {
                                                        const month = moment().set('month', key)

                                                        return (
                                                            <th key={`month-${key}`} className="w-120 text-right">
                                                                {this.props.intl.formatMessage({
                                                                    id: `monthNames.${month.format('MM')}`,
                                                                })}
                                                            </th>
                                                        )
                                                    })}
                                                    <th className="w-140 text-right">
                                                        <FormattedMessage id="fields.total" />
                                                    </th>
                                                </tr>
                                                </thead>

                                                {detailsData && (
                                                    <tbody>
                                                    <tr>
                                                        <td className="w-max wm-300">
                                                            <strong>Zisk / ztráta</strong>
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const value = detailsData.profits.months[key + 1]

                                                            return (<td key={`profits-month-${key}`} className={`w-120 text-right ${value < 0 ? 'td-danger' : ''}`}>
                                                                    <strong>{formatters.priceFormatter(value, '0,0')}</strong>
                                                                </td>)
                                                        })}
                                                        <td className={`w-140 text-right ${detailsData.profits['total'] < 0 ? 'td-danger' : ''}`}>
                                                            <strong>{formatters.priceFormatter(detailsData.profits['total'], '0,0')}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300">
                                                            <strong>Tržby</strong>
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const value = detailsData.sales.months[key + 1] + detailsData.salesTotal.months[key + 1]

                                                            return (<td key={`sales-month-${key}`} className={`w-120 text-right`}>
                                                                <strong>{formatters.priceFormatter(value, '0,0')}</strong>
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.priceFormatter(detailsData.sales.total + detailsData.salesTotal.total, '0,0')}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300">
                                                            - Z přeprav
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const value = detailsData.sales.months[key + 1]

                                                            return (<td key={`sales-month-${key}`} className={`w-120 text-right`}>
                                                                {formatters.priceFormatter(value, '0,0')}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.priceFormatter(detailsData.sales.total, '0,0')}</strong>
                                                        </td>
                                                    </tr>

                                                    {detailsData.salesByType.map(sale => {
                                                        var rows = [];

                                                        rows.push(<tr key={`sales-by-type-${sale.id}`}>
                                                            <td className="w-max wm-300">
                                                                - {sale.name}
                                                            </td>
                                                            {monthKeys.map(key => {
                                                                const value = sale.data.months[key + 1]

                                                                return (<td key={`sales-total-month-${key}`} className={`w-120 text-right`}>
                                                                    {formatters.priceFormatter(value, '0,0')}
                                                                </td>)
                                                            })}
                                                            <td className={`w-140 text-right`}>
                                                                {formatters.priceFormatter(sale.data.total, '0,0')}
                                                            </td>
                                                        </tr>);

                                                        sale.data.relationsTotals.forEach(relation => {
                                                            rows.push(<tr key={`sales-by-type-${sale.id}`}>
                                                                <td className="w-max wm-300 text-gray">
                                                                    - - {relation.name}
                                                                </td>
                                                                {monthKeys.map(key => {
                                                                    let value = sale.data.relations[key + 1] ? sale.data.relations[key + 1][relation.id] : 0

                                                                    return (<td key={`sales-total-month-${key}-relation-${relation.id}`} className={`w-120 text-right text-gray`}>
                                                                        {formatters.priceFormatter(value, '0,0')}
                                                                    </td>)
                                                                })}
                                                                <td className={`w-140 text-right text-gray`}>
                                                                    {formatters.priceFormatter(relation.total, '0,0')}
                                                                </td>
                                                            </tr>);
                                                        })

                                                        return rows
                                                    })}

                                                    <tr>
                                                        <td className="w-max wm-300">
                                                            <strong>Náklady</strong>
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const value = detailsData.costsTotal.months[key + 1]

                                                            return (<td key={`costs-total-month-${key}`} className={`w-120 text-right`}>
                                                                <strong>{formatters.priceFormatter(value, '0,0')}</strong>
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.priceFormatter(detailsData.costsTotal.total, '0,0')}</strong>
                                                        </td>
                                                    </tr>

                                                    {detailsData.costsByType.map(cost => {
                                                        var rows = [];

                                                        rows.push(<tr key={`costs-by-type-${cost.id}`}>
                                                            <td className="w-max wm-300">
                                                                - {cost.name}
                                                            </td>
                                                            {monthKeys.map(key => {
                                                                const value = cost.data.months[key + 1]

                                                                return (<td key={`costs-total-month-${key}`} className={`w-120 text-right`}>
                                                                    {formatters.priceFormatter(value, '0,0')}
                                                                </td>)
                                                            })}
                                                            <td className={`w-140 text-right`}>
                                                                {formatters.priceFormatter(cost.data.total, '0,0')}
                                                            </td>
                                                        </tr>);

                                                        cost.data.relationsTotals.forEach(relation => {
                                                            rows.push(<tr key={`costs-by-type-${cost.id}`}>
                                                                <td className="w-max wm-300 text-gray">
                                                                    - - {relation.name}
                                                                </td>
                                                                {monthKeys.map(key => {
                                                                    let value = cost.data.relations[key + 1] ? cost.data.relations[key + 1][relation.id] : 0

                                                                    return (<td key={`costs-total-month-${key}-relation-${relation.id}`} className={`w-120 text-right text-gray`}>
                                                                        {formatters.priceFormatter(value, '0,0')}
                                                                    </td>)
                                                                })}
                                                                <td className={`w-140 text-right text-gray`}>
                                                                    {formatters.priceFormatter(relation.total, '0,0')}
                                                                </td>
                                                            </tr>);
                                                        })

                                                        return rows
                                                    })}

                                                    <tr className="tr-empty">
                                                        <td colSpan={14}></td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Celková ujetá vzdálenost
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const value = detailsData.distances.months[key + 1]

                                                            return (<td key={`distances-month-${key}`} className={`w-120 text-right`}>
                                                                {formatters.distanceFormatter(value)}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.distanceFormatter(detailsData.distances.total)}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Celková spotřeba
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const value = detailsData.consumptions.months[key + 1]

                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right`}>
                                                                {formatters.volumeFormatter(value)}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.volumeFormatter(detailsData.consumptions.total)}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Celková spotřeba (norma)
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const distance = detailsData.distances.months[key + 1]

                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right text-gray`}>
                                                                {formatters.volumeFormatter(detailsData.consumptionNorm / 100 * distance)}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right text-gray`}>
                                                            <strong>{formatters.volumeFormatter(detailsData.consumptionNorm / 100 * detailsData.distances.total)}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Průměrná spotřeba
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const distance = detailsData.distances.months[key + 1]
                                                            const consumption = detailsData.consumptions.months[key + 1]
                                                            const value = distance ? consumption / distance * 100 : 0

                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right`}>
                                                                {formatters.consumptionFormatter(value)}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.consumptionFormatter(detailsData.distances.total ? detailsData.consumptions.total / detailsData.distances.total * 100 : 0)}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Průměrná spotřeba (norma)
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right text-gray`}>
                                                                {formatters.consumptionFormatter(detailsData.consumptionNorm)}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right text-gray`}>
                                                            <strong>{formatters.consumptionFormatter(detailsData.consumptionNorm)}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr className="tr-empty">
                                                        <td colSpan={14}></td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Zisk / ztráta na 1 km
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const distance = detailsData.distances.months[key + 1]
                                                            const profit = detailsData.profits.months[key + 1]
                                                            const value = distance ? profit / distance : 0

                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right ${value < 0 ? 'td-danger' : ''}`}>
                                                                {formatters.priceFormatter(value, '0,0.00')}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right ${detailsData.profits.total / detailsData.distances.total < 0 ? 'td-danger' : ''}`}>
                                                            <strong>{formatters.priceFormatter(detailsData.distances.total ? detailsData.profits.total / detailsData.distances.total : 0, '0,0.00')}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Tržba na 1 km
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const distance = detailsData.distances.months[key + 1]
                                                            const sales = detailsData.sales.months[key + 1]
                                                            const value = distance ? sales / distance : 0

                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right`}>
                                                                {formatters.priceFormatter(value, '0,0.00')}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.priceFormatter(detailsData.distances.total ? detailsData.sales.total / detailsData.distances.total : 0, '0,0.00')}</strong>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td className="w-max wm-300 m-t-lg">
                                                            Náklady na 1 km
                                                        </td>
                                                        {monthKeys.map(key => {
                                                            const distance = detailsData.distances.months[key + 1]
                                                            const costs = detailsData.costsTotal.months[key + 1]
                                                            const value = distance ? costs / distance : 0

                                                            return (<td key={`consumptions-month-${key}`} className={`w-120 text-right`}>
                                                                {formatters.priceFormatter(value, '0,0.00')}
                                                            </td>)
                                                        })}
                                                        <td className={`w-140 text-right`}>
                                                            <strong>{formatters.priceFormatter(detailsData.distances.total ? detailsData.costsTotal.total / detailsData.distances.total : 0, '0,0.00')}</strong>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                )}
                                            </table>
                                        </div>
                                    </div>)}
                                </div>
                            </div>
                        </LoadingOverlay>
                    </Modal.Body>
                    <Modal.Footer>
                        <button className="btn btn-default" onClick={this.handleHideDetails}>
                            <FormattedMessage id="confirmDialog.duplicityFound.cancel" />
                        </button>
                    </Modal.Footer>
                </Modal>
            </div>
        </PermissionsCheck>)
    }
}

function mapStateToProps(state) {
    return {
        tableModel: createTableModelSelector(tableIdentifier)(state),
        year: getYear(state),
        data: getData(state),
        fetching: getFetching(state),
        detailsData: getDetailsData(state),
        detailsFetching: getDetailsFetching(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators({
                ...ReportVehicleProfitsActionCreators, ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
            }, dispatch),
        },
        dispatch,
    }
}

function mergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...stateProps, ...dispatchProps, ...ownProps,
        table: bindActionCreators(prepareTableActionCreators(tableIdentifier, stateProps.tableModel), dispatchProps.dispatch),
    }
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps, mergeProps)(withRouter(ReportVehicleProfits)))
